package com.patronat.top.ui.molecules.header

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.LabelLarge
import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.MineShaft900

@Composable
fun PageTitleBlock(
    title: String,
    description: String?,
    modifier: Modifier = Modifier,
    titleColor: Color = MineShaft900,
    descriptionColor: Color = MineShaft500
) {
    Column(modifier = modifier) {
        Text(
            text = title,
            style = LabelLarge.copy(
                fontSize = 16.sp,
                lineHeight = 22.sp
            ),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        if (description != null) {
            Spacer(modifier = Modifier.height(4.dp))
            Text(
                text = description,
                style = BodyMedium,
                color = descriptionColor,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}